import axios from 'axios';
import { API, getSessionId } from './api';

export const listPackages = async () => {
  const { data } = await axios.get(`${API}/payments/packages`);
  return data.packages;
};

export const createCheckout = async (packageId) => {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    package_id: packageId,
    origin_url: window.location.origin,
    session_id: getSessionId(),
  });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
};
